import { formatCurrency } from 'common/FormatUtilities';
import { Delimiter, TextReplace } from 'src/shared/design-system/Utilities/TextReplace';
import { SavingsContainer } from './styles';

const SAVINGS_TEXT = `💰 Nice Work! You saved ${Delimiter} on this order!`;

export const TotalSavingsLine = ({ totalSavings }: { totalSavings?: number }) =>
  totalSavings ? (
    <SavingsContainer>
      <TextReplace replaceText={formatCurrency(totalSavings)} replaceTextElementType={'b'} text={SAVINGS_TEXT} />
    </SavingsContainer>
  ) : null;
